export interface AttachmentFileIcon {
    icon: string;
    color: string;
    isImage: boolean;
}

export const getAttachmentFileIcon = (
    name: string,
    mimeType = ""
): AttachmentFileIcon => {
    const extension = name.split(".").pop()?.toLowerCase() ?? "";

    if (
        mimeType.startsWith("image/") ||
        ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"].includes(extension)
    ) {
        return {
            icon: "image",
            color: "text-violet-600 dark:text-violet-400",
            isImage: true,
        };
    }
    if (mimeType === "application/pdf" || extension === "pdf") {
        return {
            icon: "pdf",
            color: "text-rose-600 dark:text-rose-400",
            isImage: false,
        };
    }
    if (["md", "markdown"].includes(extension)) {
        return {
            icon: "markdown",
            color: "text-slate-700 dark:text-slate-300",
            isImage: false,
        };
    }
    if (["html", "htm"].includes(extension)) {
        return {
            icon: "html",
            color: "text-orange-600 dark:text-orange-400",
            isImage: false,
        };
    }
    if (["doc", "docx", "odt", "txt", "rtf"].includes(extension)) {
        return {
            icon: "fileText",
            color: "text-blue-600 dark:text-blue-400",
            isImage: false,
        };
    }
    if (["xls", "xlsx", "csv"].includes(extension)) {
        return {
            icon: "table",
            color: "text-emerald-600 dark:text-emerald-400",
            isImage: false,
        };
    }
    if (
        ["js", "ts", "tsx", "jsx", "json", "xml", "php", "py", "sql"].includes(
            extension
        )
    ) {
        return {
            icon: "fileCode",
            color: "text-sky-600 dark:text-sky-400",
            isImage: false,
        };
    }
    if (["zip", "rar", "7z", "tar", "gz"].includes(extension)) {
        return {
            icon: "folder",
            color: "text-amber-600 dark:text-amber-400",
            isImage: false,
        };
    }

    return {
        icon: "paperclip",
        color: "text-slate-500 dark:text-slate-400",
        isImage: false,
    };
};
